import * as React from 'react';
import type { SVGProps } from 'react';
const SvgTickSquare = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={25} height={25} fill='none' {...props}>
    <g strokeLinecap='round' strokeLinejoin='round' strokeWidth={1.5}>
      <path
        stroke='#26C6DA'
        d='M9.75 22.5h6c5 0 7-2 7-7v-6c0-5-2-7-7-7h-6c-5 0-7 2-7 7v6c0 5 2 7 7 7'
      />
      <path stroke='currentColor' d='m8.5 12.5 2.83 2.83L17 9.67' />
    </g>
  </svg>
);
export default SvgTickSquare;
